import LegalPage from "./LegalPage";

const securitySections = [
  {
    title: "1. Data Protection & Confidentiality",
    body: "AuditPDF employs a strict, deterministic processing engine. We do not use third-party AI APIs or Large Language Models (LLMs) to parse your chat logs. This ensures your sensitive conversation data is never exposed to external machine learning algorithms, read by humans, or used as training data."
  },
  {
    title: "2. Zero-Retention Architecture",
    body: "To facilitate secure file delivery, generated documents are temporarily hosted in an isolated, enterprise-grade object storage environment. You are provided a secure, pre-signed URL that expires in exactly 60 minutes. Upon expiry, automated lifecycle policies permanently destroy the file from our infrastructure. No long-term backups or cached copies are ever maintained."
  },
  {
    title: "3. Encryption & Data Transit",
    body: "All data transferred between your browser and our servers is encrypted in transit using industry-standard TLS protocols. While files are temporarily held for your 60-minute download window, they are secured using AES-256 encryption at rest."
  },
  {
    title: "4. Access Controls & Authentication",
    body: "Our architecture enforces rigorous logical access controls. Cryptographic file verification operates entirely in ephemeral memory—when a file is uploaded to verify its integrity, it is hashed, compared against our secure database, and instantly discarded without ever being written to a storage disk."
  },
  {
    title: "5. Infrastructure & SOC 2 Alignment",
    body: "AuditPDF is hosted on world-class, SOC 2 Type II compliant cloud infrastructure utilising secure, isolated compute environments. This ensures that your data is processed in a highly secure, ephemeral state with enterprise-grade physical and logical protections."
  },
  {
    title: "6. GDPR & UK Data Protection Compliance",
    body: "We operate strictly in alignment with the data minimisation principles of the GDPR and UK Data Protection Act. By enforcing a Zero-Retention pipeline and processing data locally within secure instances, we ensure that no unnecessary personal data is retained or transferred."
  },
  {
    title: "7. Incident Response & Business Continuity",
    body: "Because user chat data is never stored long-term, our risk footprint is fundamentally minimised. Furthermore, we maintain automated infrastructure monitoring, immediate threat detection, and resilient deployment pipelines to ensure uninterrupted, secure service availability."
  }
];

export default function Security() {
  return (
    <LegalPage
      title="Security & Compliance | AuditPDF"
      description="AuditPDF's security and compliance posture: zero-retention architecture, encryption, GDPR/UK data protection alignment, and SOC 2 infrastructure."
      canonical="https://auditpdfhq.com/security">
      <article className="prose prose-slate max-w-4xl mx-auto py-12 px-4 md:px-0" data-testid="security-page">
        <h1 data-testid="legal-title">Security &amp; Compliance at AuditPDF</h1>
        
        <p>At AuditPDF, we understand that digital document processing requires the highest standard of confidentiality. Our architecture is designed from the ground up for strict compliance with UK and EU data protection regulations, ensuring your clients' sensitive information is protected at every stage.</p>

        {securitySections.map((section) => (
          <section key={section.title}>
            <h2>{section.title}</h2>
            <p>{section.body}</p>
          </section>
        ))}

        <p>Please contact <a href="mailto:support@auditpdfhq.com">support@auditpdfhq.com</a> to initiate a vendor security review.</p>
      </article>
    </LegalPage>
  );
}